import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import {
  createSetTransactionDataAction,
  createSetWeeklyTransactionDataAction
} from "../actions/dataActions";
import {useGetAndSet} from "./useGetAndSet";

export const useTransactionData = (params, dataFresh, action=createSetTransactionDataAction) => {
  return useGetAndSet("transactions", params, action, dataFresh)
};
